import type { ReactNode } from 'react';

interface Props {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-ink-200 bg-white/40 p-8 text-center dark:border-ink-700 dark:bg-ink-800/40">
      {icon && (
        <div className="text-2xl" aria-hidden>
          {icon}
        </div>
      )}
      <div>
        <div className="text-sm font-semibold text-ink-900 dark:text-ink-50">{title}</div>
        {description && (
          <div className="mt-1 text-xs text-ink-500 dark:text-ink-300">{description}</div>
        )}
      </div>
      {action && <div className="pt-1">{action}</div>}
    </div>
  );
}
